import React, { useEffect, useState } from "react";

const TopLeftHeart = ({ floating = true, visible = true, buildFamilyTree, members,anniversaryMemberIds }) => {
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    if (!floating || !visible) return;

    const interval = setInterval(() => {
      setAnimate((prev) => !prev);
    }, 1800);

    return () => clearInterval(interval);
  }, [floating, visible]);

  if (!visible) return null;

  const handleHeartClick = () => {
    if (buildFamilyTree) {
      buildFamilyTree(members,anniversaryMemberIds);
    }
  };

  return (
    <div
      onClick={handleHeartClick}
      style={{
        position: "fixed",
        top: "0px",
        left: "20px",
        zIndex: 1000,
        fontSize: "28px",
        cursor: "pointer",         // enable click cursor
        transform: animate ? "translateY(-6px)" : "translateY(0px)",
        transition: "transform 0.9s ease-in-out",
      }}
    >
      ❤️
    </div>
  );
};

export default TopLeftHeart;
